<template>
    <div style="height: 100%">
        <el-tabs v-model="editableTabsValue" type="card" :closable="level != 0" @edit="handleTabsEdit"
            @tab-click="tabsClick" style="width: 97%;margin: 10px auto 0;">
            <el-tab-pane :key="index" v-for="(item, index) in editableTabs" :label="item.title" :name="item.name"
                style="width: 91%;"></el-tab-pane>
        </el-tabs>
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.authName" style="width: 140px;" size="small" placeholder="请输入菜单名称"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增{{ level == 0 ?
                        '目录' : level == 1 ? '菜单' : '按钮' }}</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="authId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
                        :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑功能' : '新增功能'" :visible.sync="dialog" width="70%" top="8vh">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                    <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="父级权限id" prop="authParentId">
                            <el-input v-model="form.authParentId" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="菜单权限名称" prop="authName">
                            <el-input v-model="form.authName" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="地址" prop="authUrl">
                            <el-input v-model="form.authUrl" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="接口参数" prop="authParams">
                            <el-input v-model="form.authParams" type="textare" style="width: 50%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="描述" prop="authRemark">
                            <el-input v-model="form.authRemark" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="排序" prop="authOrder">
                            <el-input v-model="form.authOrder" type="number" style="width: 50%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="图标" prop="authIcon">
                            <el-input v-model="form.authIcon" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="操作类型(0查询 1 新增 2编辑 3删除)" prop="authOperationType">
                            <el-input v-model="form.authOperationType" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
        </div>

    </div>
</template>
  
<script>

import { getAjefAuthList, addAjefAuth, updateAjefAuth, deleteAjefAuth } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            postForm: {

            },
            authParentId: 0,
            editableTabsValue: '0',
            editableTabs: [{
                title: '目录',
                name: '0',
            }],
            tabIndex: 0,

            level: 0,
            key: 'authId',
            dialog: false,
            edit: false,
            form: {
                naName: '',
                authType: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    fixed: 'left',
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "authName",
                    key: "authName",
                    fixed: 'left',
                    title: "菜单名称",
                    width: 100,
                    align: "center",
                },
                {
                    field: "authUrl",
                    key: "authUrl",
                    fixed: 'left',
                    title: "菜单地址",
                    align: "center",
                    width: 250,
                },
                {
                    field: "authRemark",
                    key: "authRemark",
                    title: "描述",
                    align: "center",
                    width: 150,
                },
                {
                    field: "authParams",
                    key: "authParams",
                    title: "接口参数",
                    align: "center",
                    width: 250,
                },

                {
                    field: "authOrder",
                    key: "authOrder",
                    title: "排序",
                    align: "center",
                    width: 100,
                },
                {
                    field: "authIcon",
                    key: "authIcon",
                    title: "图标",
                    align: "center",
                    width: 100,
                },
                {
                    field: "authOperationType",
                    key: "authOperationType",
                    title: "操作类型",
                    width: 200,
                    align: "center",

                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.authOperationType == 0 ? <span>查询</span> : row.authType == 1 ? <span>新增</span> : row.authType == 2 ? <span>编辑</span>
                                        : <span>删除</span>
                                }
                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.authType == 0  && (row.authRemark && row.authRemark.indexOf('#', 0) == -1) ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleLevel(row)}
                                    >
                                        查看菜单
                                    </el-button> : row.authType == 1  || (row.authRemark && row.authRemark.indexOf('#', 0) > -1) ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleLevel(row)}
                                    >
                                        查看按钮
                                    </el-button> : <span></span>
                                }

                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button>
                                }
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                authType: 0,
                authParentId: 0,
                currentPage: 1,
                pageSize: 10,
            },
            tableLoading: false,
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 260 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 260 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 260 - this.windheight * 0.04;
        this.getList();
        this.getPost('region')
    },
    mounted() { },
    methods: {
        getPost(key) {
            const userpost = JSON.parse(localStorage.getItem('userPost')) || [];
            userpost.forEach((item, index) => {
                if (item.nsaMenuKey == key) {
                    this.postForm[item.nsaFuncKey] = item.nsaFuncLabel
                }
            })
        },
        tabsClick(e) {
            console.log(e);
            this.editableTabsValue = e.name;
            this.tabIndex = this.editableTabsValue;
            this.level = this.tabIndex * 1;
            this.form.authParentId = this.editableTabs[e.index * 1].authParentId || 0;
            this.authParentId = this.editableTabs[e.index * 1].authParentId || 0;
            this.formDatas.authParentId = this.editableTabs[e.index * 1].authParentId || 0;
            this.partserch()
        },
        handleTabsEdit(targetName, action) {
            if (action === 'remove') {
                let tabs = this.editableTabs;
                let activeName = this.editableTabsValue;
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if (nextTab) {
                                console.log('1', this.editableTabsValue);
                                activeName = nextTab.name;

                            }
                        }
                    });
                }

                this.editableTabsValue = activeName;
                const tabarr = this.editableTabs = tabs.filter(tab => tab.name !== targetName);
                console.log(this.editableTabs);
                this.tabIndex = tabarr[tabarr.length - 1].name;
                this.level = tabarr[tabarr.length - 1].name * 1;
                this.formDatas.authParentId = tabarr[tabarr.length - 1].authParentId || 0;
                this.partserch()
            }
        },
        handleLevel(row) {
            if (row.authRemark.indexOf('#', 0) > -1) {
                this.level = 2;
                console.log(this.level);
                this.tabIndex = this.editableTabsValue = 2 + '';
            } else {
                this.level = row.authType + 1;
                console.log(this.level);
                this.tabIndex = this.editableTabsValue = row.authType + 1 + '';
            }
            this.formDatas.authParentId = this.authParentId = row.authId;
            const s = {
                title: this.level == 1 ? '菜单' : '按钮',
                name: this.tabIndex,
                authParentId: row.authId
            }
            this.editableTabs.some((item, index) => {
                if (item.name === s.name) {

                    this.editableTabs.splice(index, 1, s)
                    console.log(this.editableTabs);
                    this.partserch();
                    return true
                } else if (index == this.editableTabs.length - 1 && item.name != s.name) {
                    this.editableTabs.push(s)
                    console.log(this.editableTabs);
                    this.partserch();
                }
            })


        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjefAuth({ authId: row.authId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjefAuth(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjefAuth(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.form.authType = this.level;
            this.form.authParentId = this.authParentId;
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            // this.form.authParentId = this.authParentId = '';
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.authId = row.authId
                    console.log(jsonObj);
                    updateAjefAuth(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefAuthList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });

        },
        partserch() {
            this.formDatas.authType = this.level;
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefAuthList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                this.tableLoading = false;
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefAuthList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.tableLoading = false;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>
  
<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
  